import type { SVGProps } from 'react';

export function FillBriefcaseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M13.5 4.193V4.64723L13.9521 4.6907C14.5168 4.745 15.0778 4.81116 15.6371 4.88823C16.7236 5.04097 17.5 5.98582 17.5 7.07V10.539C17.5 11.4669 16.9294 12.3225 16.0233 12.601C14.1183 13.1856 12.0957 13.5 10 13.5C7.90423 13.5 5.88067 13.1856 3.97675 12.601C3.07059 12.3226 2.5 11.4669 2.5 10.539V7.07C2.5 5.98436 3.27678 5.04001 4.36275 4.88925L4.36288 4.88923C4.92318 4.8113 5.48504 4.7451 6.0481 4.69068L6.5 4.647V4.193V3.75C6.5 3.15326 6.73705 2.58097 7.15901 2.15901C7.58097 1.73705 8.15326 1.5 8.75 1.5H11.25C11.8467 1.5 12.419 1.73705 12.841 2.15901C13.2629 2.58097 13.5 3.15326 13.5 3.75V4.193ZM12.47 4.5741L13 4.60599V4.075V3.75C13 2.78386 12.2161 2 11.25 2H8.75C7.78386 2 7 2.78386 7 3.75V4.075V4.60599L7.53003 4.5741C9.17519 4.4751 10.8248 4.4751 12.47 4.5741ZM10 9.5C9.60218 9.5 9.22064 9.65804 8.93934 9.93934C8.65804 10.2206 8.5 10.6022 8.5 11V11.01C8.5 11.4078 8.65804 11.7894 8.93934 12.0707C9.22064 12.352 9.60218 12.51 10 12.51H10.01C10.4078 12.51 10.7894 12.352 11.0707 12.0707C11.352 11.7894 11.51 11.4078 11.51 11.01V11C11.51 10.6022 11.352 10.2206 11.0707 9.93934C10.7894 9.65804 10.4078 9.5 10.01 9.5H10Z'
        fill='currentColor'
        stroke='currentColor'
      />
      <path
        d='M3 15.0551V14.3711C3.126 14.4241 3.255 14.4711 3.39 14.5131C5.482 15.1551 7.703 15.5001 10 15.5001C12.297 15.5001 14.518 15.1551 16.61 14.5131C16.745 14.4721 16.874 14.4241 17 14.3711V15.0551C17 16.4021 16.015 17.5851 14.637 17.7411C11.5554 18.088 8.4446 18.088 5.363 17.7411C3.985 17.5851 3 16.4021 3 15.0551Z'
        fill='currentColor'
      />
    </svg>
  );
}
